export const animationDelays = {
  navBarLinks: 0,
  heroContent: 800,
  socialFeature: 2000,
  emailFeature: 2000,
}
